import { ProviderTeam, ProviderTeamUI } from './useProviderTeams.types';

export const mapProviderTeamV1ToUI = (
  providerTeam: ProviderTeam
): ProviderTeamUI => {
  const isParent = providerTeam?.children?.length > 0;

  return {
    id: providerTeam.id,
    name: providerTeam.name,
    isParent,
    members: providerTeam.members || [],
    totalMembers: providerTeam.members_count,
    children: (providerTeam?.children || []).map(mapProviderTeamV1ToUI),
    totalChildren: (providerTeam.children || []).length
  };
};
